import { getVehiclesByNumber } from '../services/dashboardService'
import types from './types'
const { FETCH_FILTER_VEHICLES } = types

const fetchFilterVehicles = identifierNumber => dispatch => {
  return getVehiclesByNumber(identifierNumber)
    .then(vehicles => {
      dispatch({ type: FETCH_FILTER_VEHICLES, vehicles })
      vehicles.codIdentificador = identifierNumber
      return [vehicles]
    })
    .catch(error => {
      console.log('Erro em #fetchFilterVehicles()', error)
      return error
    })
}

export default fetchFilterVehicles



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchFilterVehicles.js